var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4382 6.03283L11.5443 5.92676L11.4382 5.8207L10.1793 4.56176L10.0732 4.4557L9.96717 4.56176L1.6746 12.8543L1.63067 12.8983V12.9604V14.2193V14.3693H1.78067H3.0396H3.10173L3.14567 14.3254L11.4382 6.03283ZM12.485 4.7739L12.5911 4.87996L12.6972 4.7739L13.9561 3.51496L14.0622 3.4089L13.9561 3.30283L12.6972 2.0439L12.5911 1.93783L12.485 2.0439L11.2261 3.30283L11.12 3.4089L11.2261 3.51496L12.485 4.7739ZM15.6332 3.93231L3.71555 15.85H0.15V12.2844L12.0677 0.36676C12.0677 0.366754 12.0677 0.366749 12.0677 0.366744C12.2065 0.227963 12.3948 0.15 12.5911 0.15C12.7874 0.15 12.9757 0.227963 13.1145 0.366744C13.1145 0.366749 13.1145 0.366754 13.1145 0.36676L15.6332 2.88548C15.772 3.02432 15.85 3.21259 15.85 3.4089C15.85 3.6052 15.772 3.79347 15.6333 3.9323C15.6332 3.9323 15.6332 3.93231 15.6332 3.93231Z",
    fill: "#fff",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.37e34f73d800bd568f0ef17c899ae7a4.svg";
export { ForwardRef as ReactComponent };